import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const PinMap_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.3333 4.96652L24.6667 7.4013L30.8253 5.79472C32.9372 5.24377 35 6.83748 35 9.02011V29.7625C35 31.2794 33.9758 32.605 32.5081 32.9879L24.6667 35.0335L15.3333 32.5987L9.17474 34.2053C7.06279 34.7562 5 33.1625 5 30.9799V10.2375C5 8.72061 6.02416 7.395 7.49193 7.01211L15.3333 4.96652ZM16.3333 30.7926L23.6667 32.7057V9.20737L16.3333 7.29432V30.7926ZM14.3333 7.29432V30.7926L8.6699 32.27C7.82512 32.4904 7 31.8529 7 30.9799V10.2375C7 9.63074 7.40967 9.1005 7.99677 8.94734L14.3333 7.29432ZM25.6667 9.20737V32.7057L32.0032 31.0526C32.5903 30.8995 33 30.3692 33 29.7625V9.02011C33 8.14706 32.1749 7.50957 31.3301 7.72995L25.6667 9.20737Z"
            />
        </SvgStyled>
    );
};

export default PinMap_xl;
